/**
 * The six visual checks recorded per extinguisher, in display order. The labels
 * deliberately differ from the API's (`fire-extinguisher-check.config.ts`), whose
 * wording appears in failure details such as "Pressure, Seals failed".
 */
export const FIRE_EXTINGUISHER_CHECKS = [
  { key: "locationOk", label: "Location" },
  { key: "signageOk", label: "Access & Signage" },
  { key: "pressureOk", label: "Pressure" },
  { key: "conditionOk", label: "Condition" },
  { key: "sealsOk", label: "Seals & Pins" },
  { key: "hardwareOk", label: "Hardware" },
] as const;

export type FireExtinguisherCheckKey =
  (typeof FIRE_EXTINGUISHER_CHECKS)[number]["key"];
